
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/movies",
      function () {
        return require("private-next-pages/[locale]/movies/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/movies"])
      });
    }
  